/* eslint-disable react-refresh/only-export-components -- Styles module that also exports one small react-select subcomponent. */
/**
 * Shared styles and color constants for react-select components
 */
import { components } from 'react-select';

// Color constants matching SCSS variables from colors.module.scss
export const COLORS = {
    GRAY_1: '#f9f9f9', // Background color for form inputs (was #f7f7f7)
    GRAY_4: '#d3d8df', // Border color (was #d8d8d8)
    GRAY_5: '#808080', // Placeholder and arrow color (was #8c8c8c)
    GRAY_8: '#333', // Text color (was #3d3d3d)
};

/**
 * Custom DropdownIndicator that renders a filled triangle (like v1)
 * Flips direction when menu is open, just like v1 behavior
 */
export const FilledTriangleDropdownIndicator = props => {
    const { selectProps } = props;
    const isOpen = selectProps.menuIsOpen;

    return (
        <components.DropdownIndicator {...props}>
            {isOpen ? (
                // Upward pointing triangle when open
                <svg width="10" height="6" viewBox="0 0 10 6" fill="currentColor">
                    <path d="M0 6 L5 0 L10 6 Z" />
                </svg>
            ) : (
                // Downward pointing triangle when closed
                <svg width="10" height="6" viewBox="0 0 10 6" fill="currentColor">
                    <path d="M0 0 L5 6 L10 0 Z" />
                </svg>
            )}
        </components.DropdownIndicator>
    );
};

/**
 * Custom styles for SelectFieldEditor component
 * Matches the v1 react-select appearance
 */
export const selectFieldEditorStyles = {
    control: base => ({
        ...base,
        backgroundColor: COLORS.GRAY_1,
        border: `1px solid ${COLORS.GRAY_4}`,
        borderRadius: '2px',
        minHeight: '36px',
        maxHeight: '36px',
    }),
    placeholder: base => ({
        ...base,
        color: COLORS.GRAY_5,
    }),
    singleValue: base => ({
        ...base,
        color: COLORS.GRAY_8,
    }),
    menuList: base => ({
        ...base,
        maxHeight: '198px',
        paddingTop: 0,
        paddingBottom: 0,
    }),
    menu: base => ({
        ...base,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderTopColor: '#e6e6e6',
        borderBottomRightRadius: '4px',
        borderBottomLeftRadius: '4px',
        boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)',
        marginTop: '-1px',
        maxHeight: '200px',
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? 'rgba(0, 126, 255, 0.04)'
            : state.isFocused
              ? 'rgba(0, 126, 255, 0.08)'
              : '#fff',
        color: state.isSelected || state.isFocused ? '#333' : '#666666',
        cursor: 'pointer',
        padding: '8px 10px',
        ':active': {
            backgroundColor: 'rgba(0, 126, 255, 0.08)',
        },
    }),
    dropdownIndicator: base => ({
        ...base,
        color: COLORS.GRAY_5,
        cursor: 'pointer',
    }),
    indicatorSeparator: () => ({
        display: 'none', // Hide the vertical line
    }),
};

/**
 * Custom styles for TopBar select components (venue/config selectors)
 * Uses larger font size and no borders
 */
export const topBarSelectStyles = {
    control: base => ({
        ...base,
        border: 'none',
        boxShadow: 'none',
        minHeight: '36px',
    }),
    singleValue: base => ({
        ...base,
        fontSize: '22px',
        fontWeight: 500,
        lineHeight: '36px',
    }),
    valueContainer: base => ({
        ...base,
        paddingRight: '24px',
    }),
    container: base => ({
        ...base,
        width: '450px',
    }),
    menuList: base => ({
        ...base,
        maxHeight: '198px',
        paddingTop: 0,
        paddingBottom: 0,
    }),
    menu: base => ({
        ...base,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderTopColor: '#e6e6e6',
        borderBottomRightRadius: '4px',
        borderBottomLeftRadius: '4px',
        boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)',
        marginTop: '-1px',
        maxHeight: '200px',
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? 'rgba(0, 126, 255, 0.04)'
            : state.isFocused
              ? 'rgba(0, 126, 255, 0.08)'
              : '#fff',
        color: state.isSelected || state.isFocused ? '#333' : '#666666',
        cursor: 'pointer',
        padding: '8px 10px',
        ':active': {
            backgroundColor: 'rgba(0, 126, 255, 0.08)',
        },
    }),
    dropdownIndicator: base => ({
        ...base,
        color: COLORS.GRAY_5,
        cursor: 'pointer',
    }),
    indicatorSeparator: () => ({
        display: 'none', // Hide the vertical line
    }),
};
